import { render, staticRenderFns } from "./VesselsDashboardLists.vue?vue&type=template&id=04beccf3&"
import script from "./VesselsDashboardLists.vue?vue&type=script&lang=js&"
export * from "./VesselsDashboardLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports